import type { productReturnRequestAttachmentDisplayVM } from "./productReturnRequestAttachmentDisplayVM";

export default function ProductReturnRequestAttachmentDisplayFragment(props: {
  items: productReturnRequestAttachmentDisplayVM[];
}) {
  return (
    <ol>
      {props.items.map((item) => (
        <li key={item.id}>
          <a
            href={"/api/ProductReturns/AttachmentDownload/Open/" + item.id}
            target="_blank"
            title="Otwórz plik"
          >
            {item.attachmentName}
          </a>
          &nbsp;
          <a
            href={"/api/ProductReturns/AttachmentDownload/Download/" + item.id}
            title="Pobierz plik"
          >
            <i className="bi bi-file-earmark-arrow-down-fill"></i>
          </a>
        </li>
      ))}
    </ol>
  );
}
